import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_dropdown_header = _resolveComponent("b-dropdown-header");
  const _component_marketplace_value = _resolveComponent("marketplace-value");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_dropdown_body = _resolveComponent("dropdown-body");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  return $props.list.length === 1 ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: $props.list[0].redirect_link,
    target: "_blank"
  }, [_renderSlot(_ctx.$slots, "button-content")], 8, _hoisted_1)) : (_openBlock(), _createBlock(_component_b_dropdown, {
    key: 1,
    "no-caret": "",
    ref: "dropdown",
    menuClass: ['list-marketplace-value'],
    toggleClass: "list-marketplace-value",
    container: "body",
    dropup: "",
    onShown: _cache[0] || (_cache[0] = $event => $setup.shown = true),
    onHidden: _cache[1] || (_cache[1] = $event => $setup.shown = false)
  }, {
    "button-content": _withCtx(() => [_renderSlot(_ctx.$slots, "button-content", {
      shown: $setup.shown
    })]),
    default: _withCtx(() => [_createVNode(_component_b_dropdown_header, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.header), 1)]),
      _: 1
    }), _createVNode(_component_dropdown_body, {
      class: "filter-dropdown-body"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, index) => {
        return _openBlock(), _createElementBlock("a", {
          key: index,
          href: item?.redirect_link,
          target: "_blank"
        }, [_createVNode(_component_b_dropdown_item, null, {
          default: _withCtx(() => [_createVNode(_component_marketplace_value, {
            marketplace: item?.sales_channel,
            flag: item?.flag
          }, null, 8, ["marketplace", "flag"])]),
          _: 2
        }, 1024)], 8, _hoisted_2);
      }), 128))]),
      _: 1
    })]),
    _: 3
  }, 512));
}